export function scrollId(id, offset = 100) {
  console.log(id);
  var element = document.getElementById(id);
  var headerOffset = offset;
  var elementPosition = element.getBoundingClientRect().top;
  var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
  window.scrollTo({
    top: offsetPosition,
    behavior: "smooth",
  });
}

export function hoy() {
  var today = new Date();
  var dd = String(today.getDate()).padStart(2, "0");
  var mm = String(today.getMonth() + 1).padStart(2, "0");
  var yyyy = today.getFullYear();
  return dd + "/" + mm + "/" + yyyy;
}

export function ahora() {
  var today = new Date();
  var hh = String(today.getHours()).padStart(2, "0");
  var mm = String(today.getMinutes()).padStart(2, "0");
  return hh + ":" + mm;
}

export async function archivoBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
